module.exports = __webpack_public_path__ + "static/media/thrust.53365ac4.wav";